import React, { useState, useEffect } from 'react';
import './CustomAlert.css';

const CustomAlert = ({
  show,
  title,
  children,
  onConfirm,
  onClose,
  confirmButtonText = 'OK',
  cancelButtonText = 'Fechar',
  showCancelButton = true,
}) => {
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    if (show) {
      setIsClosing(false);
    }
  }, [show]);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      onClose();
      setIsClosing(false);
    }, 400); // Duração da animação
  };

  const handleConfirm = () => {
    setIsClosing(true);
    setTimeout(() => {
      onConfirm();
      setIsClosing(false);
    }, 400); // Duração da animação
  };

  if (!show) {
    return null;
  }

  return (
    <div 
      className={`custom-alert-overlay ${isClosing ? 'closing' : ''}`} 
      onClick={handleClose}
    >
      <div 
        className={`custom-alert-popup ${isClosing ? 'closing' : ''}`} 
        onClick={(e) => e.stopPropagation()}
      >
        <div className="custom-alert-header">
          <h2 className="custom-alert-title">{title}</h2>
        </div>
        <div className="custom-alert-content">
          {children}
        </div>
        <div className="custom-alert-footer">
          {showCancelButton && (
            <button onClick={handleClose} className="custom-alert-button custom-alert-cancel-button">
              <span className="custom-alert-button-icon">×</span>
              {cancelButtonText}
            </button>
          )}
          {onConfirm && (
            <button onClick={handleConfirm} className="custom-alert-button custom-alert-confirm-button">
              {confirmButtonText}
              <span className="custom-alert-button-icon">→</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomAlert;